import {UserTracker} from "../index.js";

const eventDics = {
    "normal-login-click": "sign-in:normal-login:click", // 일반 로그인 클릭
    "normal-login-enter": "sign-in:normal-login:enter", // 일반 로그인 엔터
    "mini-login-click": "mini-sign-in:normal-login:click", // 미니 로그인 클릭
    "mini-login-enter": "mini-sign-in:normal-login:enter", // 미니 로그인 엔터
    "google-login": "sign-in:google-login:click", // 구글 로그인 클릭
    "kakao-login": "sign-in:kakao-login:click", // 카카오 로그인 클릭
    "apple-login": "sign-in:apple-login:click", // 애플 로그인 클릭
    // "mini-sns-login": "mini-sign-in:sns-login:click", // 미니 소셜 로그인 버튼 클릭
    "google-mini-login": "mini-sign-in:google-login:click", // 미니 구글 로그인 클릭
    "kakao-mini-login": "mini-sign-in:kakao-login:click", // 미니 카카오 로그인 클릭
    "apple-mini-login": "mini-sign-in:apple-login:click", // 미니 애플 로그인 클릭
    "pw-find": "sign-in:pw-find:click", // 비밀번호 찾기 클릭
    "mini-pw-find": "mini-sign-in:pw-find:click", // 미니 비밀번호 찾기 클릭
    "corp-pw-find": "corp-sign-in:pw-find:click", // 기관 비밀번호 찾기 클릭
    "pw-find-email-click": "sign-in:pw-find-email:click", // 비밀번호 변경 이메일 받기 클릭
    "pw-find-email-enter": "sign-in:pw-find-email:enter", // 비밀번호 변경 이메일 받기 엔터
    "auto-login-check": "sign-in:auto-login-check:click", // 자동 로그인 클릭
}

export const SignInTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName, value = null) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value, data: {}});
    }

    return Tracker;
}

// UserTracker?.SignInTracker()?.track("auto-login-check", autoLoginCheckedYN)
// UserTracker?.SignInTracker()?.track("normal-login-click");
// UserTracker?.SignInTracker()?.track(_IsMini ? "mini-login-click" : "normal-login-click");
